const exportIds = new Set<string>();

/**
 * The exports a mounted report page is waiting on or holding as a download link. The ready
 * notification for one of these is already on screen as that page's button and raises no toast.
 */
export const reportExportsOnScreen = {
	add: (exportId: string) => exportIds.add(exportId),
	remove: (exportId: string) => exportIds.delete(exportId),
	has: (exportId: string) => exportIds.has(exportId),
};
